import * as yup from 'yup';

const initialValues = {
  comments: '',
  feedbackDate: '',
};

const validationSchema = yup.object().shape({
  comments: yup.string().required('Comment is required').nullable(),
  feedbackDate: yup
    .string()
    .required('Feedback meeting date is required')
    .nullable(),
});

export { initialValues, validationSchema };
